let conf = require("./.mui-persist/alernative-store.json");

const configureEnv = {
    initialize: async function () {
        if (!conf.component) global.conf = { ...conf, ...global.conf };

        if (conf.component) {
            if (!global.conf) global.conf = { env: conf.env };
            if (!global.conf.env) global.conf.env = conf.env;
            let env = global.conf ? global.conf.env : conf.env;
            let confEnv = conf.enviroments[env];
            if (!Object.keys(global.conf).includes(conf.addonName)) {
                global.conf = { ...global.conf, [conf.addonName]: confEnv };
            } else {
                global.conf = {
                    ...global.conf,
                    [conf.addonName]: { ...global.conf[conf.addonName], ...confEnv },
                };
            }
        }
    },
};

(() => {
    configureEnv.initialize();
})();

module.exports = configureEnv;
